import * as React from 'react';
export const IcSmartBulbDimmable = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14 20h-4a1 1 0 000 2h4a1 1 0 000-2zM11.88 2A7.1 7.1 0 005 8.74a7 7 0 002.85 5.89A2.9 2.9 0 019 17a1 1 0 001 1h4a1 1 0 001-1 2.858 2.858 0 011.13-2.34A7 7 0 0011.88 2zm2.83 9.71l-2 2A1.001 1.001 0 0112 14a.84.84 0 01-.38-.08A1 1 0 0111 13V8.41l-.29.3a1.004 1.004 0 01-1.42-1.42l2-2a1 1 0 011.09-.21A1 1 0 0113 6v4.59l.29-.3a1.004 1.004 0 011.42 1.42z'
      fill='currentColor'
    />
  </svg>
);
